kv.controller('vatTypeListCtrl', function ($element, $attrs, $scope, $injector) {
	return new dictionaryListCtrl($element, $attrs, $scope, $injector, {
		primaryKey: "vat_type_id",
		entity: "vat_type",
		modal: {
			templateUrl: "vat_type-edit",
			controller: "vatTypeEditCtrl"
		}
	});
});
